import cn from 'classnames';
import { useEffect, useId } from 'react';
import { warehouseModel } from '@entities/warehouse';
import { EditBag } from '@features/edit-bag';
import { getBagPlace } from '@lib/bag-formatting';
import { dateFormatter, DATE_TIME_FORMAT } from '@lib/date-formatting';
import { useStore } from 'effector-react';
import { EmptyBag } from './bag-empty';
import { FilledBag } from './bag-filled';
import { $selectedSleeveId } from '@widgets/storage-viewer/model';
import { IBag } from '@@/bags/ts';

import styles from './styles.module.css';
import {
  $agricultureModalIdEnable,
  $copyBagModalEnable,
  closeAgricultureModal,
  copyAgricultureModal,
} from '@@/agriculture/store/agriculture.store';
import { FillBagModal } from '@@/bags/components/fill-bag-modal';
import { CopyBagModal } from '@@/bags/components/copy-bag-modal';
// import { UiButton } from '@@/ui/components/ui-button';
// import { $isFillingWarehouseBag } from '@entities/warehouse/store';

const { WAREHOUSE_TYPES } = warehouseModel;

export const BagsList = ({ warehouseType }: { warehouseType: number }) => {
  const bags = useStore(warehouseModel.$warehouseBags);
  const bagType = warehouseType === WAREHOUSE_TYPES.sleeve ? 'sleeve' : 'bunker';
  const editPanelType = bagType === 'sleeve' ? 'full' : 'compact';
  const rootClass = cn(
    styles.bags,
    bagType === 'sleeve' ? styles.sleeves : styles.bunkers,
  );
  const [agricultureModalIdEnable] = useStore($agricultureModalIdEnable);

  const copyBagModalEnable = useStore($copyBagModalEnable);

  const editAgricultureId = bags.find(
    (b) => b.id == agricultureModalIdEnable,
  )?.agricultureId;

  const selectedSleeveId = useStore($selectedSleeveId);

  useEffect(() => {
    if (!selectedSleeveId) return;

    const currentSleeveElement = document.querySelector(
      `[data-bag-id="${selectedSleeveId}"]`,
    );
    if (currentSleeveElement)
      currentSleeveElement.scrollIntoView({ behavior: 'smooth' });
  }, [selectedSleeveId]);

  return (
    <div className={rootClass}>
      {bags.map((bag) =>
        bag.agricultureId ? (
          <FilledBag
            id={bag.id}
            key={bag.id}
            type={bagType}
            reservedWeight={Number(bag.reservedWeight) || 0}
            actions={<EditPanel type={editPanelType} bag={bag} />}
            data-bag-id={bag.id}
          />
        ) : (
          <EmptyBag
            id={bag.id}
            key={bag.id}
            type={bagType}
            editPanel={<EditPanel type={editPanelType} bag={bag} />}
            data-bag-id={bag.id}
          />
        ),
      )}
      {/*{agricultureModalIdEnable && (*/}
      {/*  <FillBagModal*/}
      {/*    id={agricultureModalIdEnable}*/}
      {/*    onClose={() => closeAgricultureModal()}*/}
      {/*  />*/}
      {/*)}*/}
      {copyBagModalEnable && (
        <CopyBagModal
          availableCount={bags.filter((b) => !b.weight).length}
          bagId={agricultureModalIdEnable}
          warehouseId={selectedSleeveId}
          bagType={bagType}
        />
      )}
    </div>
  );
};

const EditPanel = ({ bag, type = 'full' }: { type: 'full' | 'compact'; bag: IBag }) => {
  const bagPlace = getBagPlace(bag.id);
  const fillDate = bag.fillingDate
    ? dateFormatter(bag.fillingDate).format(DATE_TIME_FORMAT)
    : null;
  const burgerSize = type === 'full' ? 'big' : 'small';

  return (
    <div className={styles.editPanel}>
      {type === 'full' && (
        <div className={styles.placeAndFillDate}>
          <div className={styles.place}>
            <span>место:</span>
            <span className={styles.placeNum}>{bagPlace}</span>
          </div>
          <div className={styles.fillDate}>{fillDate}</div>
        </div>
      )}
      <EditBag burgerSize={burgerSize} bag={bag} />
    </div>
  );
};
